import moment from 'moment';
import {
  ActionType,
  BooleanField,
  FormField,
  SelectAutocompleteField,
  SelectField,
} from '../../components/AutoForm/AutoFieldNew';
import {Pot} from '../../schema-types/Pot';
import {DocumentUploadPlanNumberStatus} from '../../schema-types/globalTypes';

export const notesField: FormField = {
  type: ActionType.text,
  readOnly: false,
  canBeEmpty: true,
  id: 'notes',
  label: 'Notes',
  multiline: true,
  minRows: 2,
  charLimit: 255,
};

export const datePickerField = (datePicker: string): FormField => ({
  type: ActionType.datepicker,
  id: 'datePicker',
  label: datePicker || 'Date Picker',
  multiyear: true,
  fullWidth: true,
  maxDate: moment(), //  This field should only allow the current date and dates in the past.
  initialValue: undefined,
});

interface Options {
  value: string;
  label: string;
}

export const contactNameField = (id: string, options: Options[]): SelectField => {
  return {
    type: ActionType.select,
    id,
    label: id === 'contactName1' ? 'Contact Name 1' : 'Contact Name 2',
    fullWidth: true,
    options,
    initialValue: '',
  };
};

export const providerField: SelectAutocompleteField = {
  type: ActionType.selectAutocomplete,
  id: 'providerId',
  label: 'Provider',
  options: [],
};

export const planNumberField = (pots: Pot[]): SelectField => ({
  type: ActionType.select,
  id: 'planNumber',
  label: 'Plan Number',
  options:
    pots.map((pot) => ({
      value: pot.id,
      label: pot.name || 'Unknown',
      disabled: false,
    })) || [],
});

export const taxYearField: SelectField = {
  type: ActionType.select,
  id: 'taxYear',
  label: 'Tax Year',
  options: [],
};

export const planNumberStatusField: BooleanField = {
  id: 'planNumberStatus',
  label: 'Plan number not listed',
  type: ActionType.boolean,
  yesValue: DocumentUploadPlanNumberStatus.PLAN_NUMBER_NEEDED_NOT_KNOWN,
  noValue: DocumentUploadPlanNumberStatus.PLAN_NUMBER_NEEDED_KNOWN,
  labelNotClickable: true,
  initialValue: DocumentUploadPlanNumberStatus.PLAN_NUMBER_NEEDED_KNOWN,
};
